import React, { useRef } from 'react';
import Link from './Link';
import Logo from './Logo';

import { useIntersection } from 'use-intersection';
import isEmpty from 'lodash/isEmpty';
import cx from 'classnames';

const Footer = ({ desktopMenu, mobileMenu = [] }) => {
    const half = Math.ceil(mobileMenu.length / 2);
    const leftMobile = mobileMenu.slice(0, half);
    const rightMobile = mobileMenu.slice(-half);

    const leftDesktop = isEmpty(desktopMenu) ? [] : desktopMenu.left;
    const rightDesktop = isEmpty(desktopMenu) ? [] : desktopMenu.right;

    const target = useRef(null);
    const isIntersected = useIntersection(target, {
        rootMargin: '-20%',
        once: true,
    });

    return (
        <footer
            ref={target}
            className={cx('site-footer bg--peach-deep pt2 pb2 pt3--lg reveal', {
                active: isIntersected,
            })}
        >
            <nav className="grid-container contained df fdc fdrr--lg jcb site-footer__nav">
                <div className="site-footer__column pt3--lg pl3--lg">
                    <div className="klaviyo-form-WtZgWU"></div>
                    {/* <FooterNewsletter /> */}
                    <a
                        href="https://www.instagram.com/fenn.store/"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="mono--12 uppercase show--lg mt5 db fit link--underline-revert"
                    >
                        Connect with us on Instagram →
                    </a>
                </div>
                <div className="site-footer__column site-footer__column--border pt3--lg pl3--lg pt4 pt0--lg">
                    <nav className="hide--lg df">
                        <div className="site-footer__mobile-list--left pt2 pb4">
                            {leftMobile.map((link, index) => (
                                <Link
                                    className={cx(
                                        'mono--11 uppercase db link--underline-revert fit',
                                        {
                                            mt2: index > 0,
                                        }
                                    )}
                                    key={link._key}
                                    {...link}
                                />
                            ))}
                        </div>
                        <div className="site-footer__mobile-list--right pl2 pt2 pb4">
                            {rightMobile.map((link, index) => (
                                <Link
                                    className={cx(
                                        'mono--11 uppercase db link--underline-revert fit',
                                        {
                                            mt2: index > 0,
                                        }
                                    )}
                                    key={link._key}
                                    {...link}
                                />
                            ))}
                        </div>
                    </nav>
                    <nav className="site-footer__column-nav show--lg">
                        {rightDesktop.map((link, index) => (
                            <Link
                                className={cx(
                                    'mono--12 uppercase db link--underline-revert fit',
                                    {
                                        mt2: index > 0,
                                    }
                                )}
                                key={link._key}
                                {...link}
                            />
                        ))}
                    </nav>
                </div>
                <div className="site-footer__column site-footer__column--border pt3--lg show--lg">
                    <nav className="site-footer__column-nav show--lg">
                        {leftDesktop.map((link, index) => (
                            <Link
                                className={cx(
                                    'mono--12 uppercase db link--underline-revert fit',
                                    {
                                        mt2: index > 0,
                                    }
                                )}
                                key={link._key}
                                {...link}
                            />
                        ))}
                    </nav>
                </div>
            </nav>
            <section className="grid-container contained df jcb aib">
                <small className="copyright mono--12">
                    © FENN {new Date().getFullYear()}
                </small>
                <Logo className="site-footer__logo" />
            </section>
        </footer>
    );
};

export default Footer;